export default "__VITE_ASSET__lqXPQXzQ__"